import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaAvaliacaoPreOperatoria.vue?vue&type=template&id=a64b0fc6&scoped=true"
import script from "./ModalSolicitacaoCirurgiaAvaliacaoPreOperatoria.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaAvaliacaoPreOperatoria.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaAvaliacaoPreOperatoria.vue?vue&type=style&index=0&id=a64b0fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64b0fc6",
  null
  
)

export default component.exports